var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 25.6667C11 23.6416 12.6416 22 14.6667 22L73.3333 22C75.3584 22 77 23.6416 77 25.6667C77 27.6917 75.3584 29.3333 73.3333 29.3333L14.6667 29.3333C12.6416 29.3333 11 27.6917 11 25.6667Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 62.3333C11 60.3083 12.6416 58.6667 14.6667 58.6667L73.3333 58.6667C75.3584 58.6667 77 60.3083 77 62.3333C77 64.3584 75.3584 66 73.3333 66L14.6667 66C12.6416 66 11 64.3584 11 62.3333Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6667 73.3333C42.7419 73.3333 47.6667 68.4085 47.6667 62.3333C47.6667 56.2582 42.7419 51.3333 36.6667 51.3333C30.5916 51.3333 25.6667 56.2582 25.6667 62.3333C25.6667 68.4085 30.5916 73.3333 36.6667 73.3333Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3333 36.6667C57.4084 36.6667 62.3332 31.7418 62.3332 25.6667C62.3332 19.5915 57.4084 14.6667 51.3333 14.6667C45.2581 14.6667 40.3333 19.5915 40.3333 25.6667C40.3333 31.7418 45.2581 36.6667 51.3333 36.6667Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledIcon);
export default __webpack_public_path__ + "static/media/filledIcon.5f34c48d954b34d43ca90a4375893455.svg";
export { ForwardRef as ReactComponent };